import React from "react";
import "./App.css";
import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter as Router } from "react-router-dom";
import PageContainer from "./components/pageContainer/PageContainer";
import { UserRoleAndAuthProvider } from "./context/UserRoleAndAuthContext";
import { UserProvider } from "./context/userSignedInContext";
import useFacebookPixel from "./hooks/useFacebookPixel";
import Navigation from "./Navigation";
import { theme } from "./utils/breakPoints";
import useTiktokPixel from "./hooks/useTiktokPixel";

function App() {
  useFacebookPixel("1318973915633427");
  useTiktokPixel('CVLQCFBC77UFF3803LNG');

  return (
    <ChakraProvider theme={theme}>
      <UserProvider>
        <Router>
          <UserRoleAndAuthProvider>
            <PageContainer>
              <Navigation />
            </PageContainer>
          </UserRoleAndAuthProvider>
        </Router>
      </UserProvider>
    </ChakraProvider>
  );
}

export default App;
